// Что делать с ответом сервера на попытку войти в лобби по ссылке-приглашению.
// Вынесено из App.js отдельной чистой функцией: веток много, и перепутать
// «лобби больше нет» с «нет связи» легко — а сообщения игроку у них разные.
export const INVITED_LOBBY_JOIN_OUTCOMES = {
  // Вошли: открываем лобби из ответа
  ENTER_LOBBY: 'ENTER_LOBBY',
  // Игрок уже состоит в другом лобби — сервер вернул его id
  ENTER_OTHER_LOBBY: 'ENTER_OTHER_LOBBY',
  // Рейтинговое лобби, а фракций у игрока меньше четырех
  NOT_ENOUGH_FACTIONS: 'NOT_ENOUGH_FACTIONS',
  // Все места заняты (ботов ради вошедшего не вытесняют)
  LOBBY_IS_FULL: 'LOBBY_IS_FULL',
  // Рейтинговое лобби, состав которого набирает матчмейкинг: со стороны
  // туда не попасть (см. RANK_MATCH_JOIN_NOT_ALLOWED в server/index.js)
  RANK_MATCH_NOT_ALLOWED: 'RANK_MATCH_NOT_ALLOWED',
  // Рейтинговое лобби уже начало подготовку к матчу (баны фракций либо выбор
  // после них) — состав закрыт (см. RANK_MATCH_PHASE_STARTED в server/index.js)
  RANK_MATCH_PHASE_STARTED: 'RANK_MATCH_PHASE_STARTED',
  // Любой другой ОПРЕДЕЛЕННЫЙ отказ сервера: чаще всего 404 — матч
  // закончился и лобби удалено (см. finalizeGame в server/index.js), либо
  // 403 у приватного лобби, либо 5xx
  UNAVAILABLE: 'UNAVAILABLE',
};

// Приглашение израсходовано (сервер ответил определенно) — во всех исходах,
// кроме сетевого сбоя, который сюда вообще не доходит
export const resolveInvitedLobbyJoinOutcome = (response, data = {}) => {
  if (response.ok) {
    return {kind: INVITED_LOBBY_JOIN_OUTCOMES.ENTER_LOBBY, lobbyId: data.lobbyId};
  }

  if (data.error === 'NOT_ENOUGH_FACTIONS') {
    return {
      kind: INVITED_LOBBY_JOIN_OUTCOMES.NOT_ENOUGH_FACTIONS,
      availableCount: data.availableCount || 0,
    };
  }

  if (data.error === 'LOBBY_IS_FULL') {
    return {kind: INVITED_LOBBY_JOIN_OUTCOMES.LOBBY_IS_FULL, maxPlayers: data.maxPlayers};
  }

  if (data.error === 'RANK_MATCH_JOIN_NOT_ALLOWED') {
    return {kind: INVITED_LOBBY_JOIN_OUTCOMES.RANK_MATCH_NOT_ALLOWED};
  }

  if (data.error === 'RANK_MATCH_PHASE_STARTED') {
    return {kind: INVITED_LOBBY_JOIN_OUTCOMES.RANK_MATCH_PHASE_STARTED};
  }

  if (data.error === 'Player is already in another lobby' && data.lobbyId) {
    return {kind: INVITED_LOBBY_JOIN_OUTCOMES.ENTER_OTHER_LOBBY, lobbyId: data.lobbyId};
  }

  return {kind: INVITED_LOBBY_JOIN_OUTCOMES.UNAVAILABLE, status: response.status, error: data.error};
};

// Тексты для списка лобби, куда игрок попадает вместо приглашения
export const INVITED_LOBBY_UNAVAILABLE_MESSAGE =
  'Лобби из приглашения уже недоступно — возможно, матч в нем уже закончился. '
  + 'Выберите лобби из списка или создайте свое.';

export const RANK_MATCH_JOIN_NOT_ALLOWED_MESSAGE =
  'В рейтинговый матч можно попасть только через поиск матча — по ссылке в него не войти.';

export const RANK_MATCH_PHASE_STARTED_MESSAGE =
  'В этом рейтинговом лобби уже идет подготовка к матчу — баны фракций и выбор. '
  + 'Присоединиться к нему больше нельзя.';

export const INVITED_LOBBY_NETWORK_ERROR_MESSAGE =
  'Не удалось связаться с сервером. Приглашение сохранено — откройте игру еще раз, когда появится связь.';
